import { Injectable, signal } from '@angular/core';
import { AuthChangeEvent, Session } from '@supabase/supabase-js';
import { SupabaseClientService } from './supabase-client.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  roles = signal<string[]>([]);

  constructor(private supabaseSrv: SupabaseClientService) {

    this.supabaseSrv.client.auth.onAuthStateChange(
      (_event: AuthChangeEvent, session: Session | null) => {

        if (!session) {
          this.roles.set([]);
          return;
        }

        const payload = this.parseJwtPayload(session.access_token);


        //console.log('payload',payload);
        this.roles.set(
          payload?.app_metadata?.roles ?? []
        );

      }
    );
  }

  async signUp(email: string, password: string) {
    //return await this.supabaseSrv.client.auth.signUp({
    //  email,
    //  password
    //});

    return await this.supabaseSrv.client.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: this.buildRedirectUrl('/auth/confirm')
      }
    });


  }

  async signIn(email: string, password: string) {
    return await this.supabaseSrv.client.auth.signInWithPassword({
      email,
      password
    });
  }

  async requestPasswordReset(email: string) {
    return await this.supabaseSrv.client.auth.resetPasswordForEmail(email, {
      redirectTo: this.buildRedirectUrl('/auth/resetpwd')
    });
  }

  async signOut() {
    return await this.supabaseSrv.client.auth.signOut({ scope: 'local' });
  }

  async getUser() {
    await this.getSession();
    return await this.supabaseSrv.client.auth.getUser();
  }

  async getSession() {
    const { data: current } = await this.supabaseSrv.client.auth.getSession();
    const session = current.session;

    if (!session) {
      this.roles.set([]);
      return {
        data: { session: null },
        error: null
      };
    }

    const expiresAtMs = Number(session.expires_at ?? 0) * 1000;
    const shouldRefresh = !expiresAtMs || expiresAtMs - Date.now() < 60_000;

    if (!shouldRefresh) {
      return {
        data: { session },
        error: null
      };
    }

    const refreshed = await this.supabaseSrv.client.auth.refreshSession();
    if (refreshed.error) {
      this.roles.set([]);
      await this.supabaseSrv.client.auth.signOut({ scope: 'local' });
      return {
        data: { session: null },
        error: refreshed.error
      };
    }

    return {
      data: { session: refreshed.data.session },
      error: null
    };
  }
  //async getUsers(): Promise<{
  //  data: ListUsersResponse | null;
  //  error: { message: string } | null;
  //}> {

  //  const { data: refreshData } =
  //    await this.supabaseSrv.client.auth.refreshSession();

  //  const accessToken =
  //    refreshData.session?.access_token;

  //  if (!accessToken) {
  //    return {
  //      data: null,
  //      error: { message: 'No access token after refresh' }
  //    };
  //  }

  //  const { data, error } = await this.supabaseSrv.client.functions.invoke<ListUsersResponse>('list-users');

  //  if (error) {
  //    return {
  //      data: null,
  //      error: { message: error.message }
  //    };
  //  }

  //  return {
  //    data,
  //    error: null
  //  };
  //}

  async deleteAccount() {
    await this.supabaseSrv.client.auth.refreshSession();

    const { data, error } =
      await this.supabaseSrv.client.functions.invoke('delete-account');

    if (error) {
      return {
        data: null,
        error: {
          message: error.message
        }
      };
    }

    return {
      data,
      error: null
    };
  }


  async updatePassword( password: string) {
    return await this.supabaseSrv.client.auth.updateUser({
      password: password
    });
  }

  async updateDisplayName(displayName: string) {
    return await this.supabaseSrv.client.auth.updateUser({
      data: {
        display_name: displayName,
        nickname: displayName,
        full_name: displayName
      }
    });
  }

  async updatePhone(phone: string) {
    return await this.supabaseSrv.client.auth.updateUser({
      data: {
        phone
      }
    });
  }

  async getRoles(): Promise<string[]> {

    const { data } =
      await this.getSession();

    const token = data.session?.access_token;

    if (!token) return [];

    const payload = this.parseJwtPayload(token);

    return payload?.app_metadata?.roles ?? [];

  }
  hasAnyRole(required: string[]): boolean {

    const userRoles = this.roles();

    return required.some(r =>
      userRoles.includes(r)
    );
  }

  private buildRedirectUrl(path: string): string {
    const origin =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost:4200';

    return `${origin}${path}`;
  }

  private parseJwtPayload(token: string): any {
    try {
      const payload = token.split('.')[1] ?? '';
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
      return JSON.parse(atob(padded));
    } catch {
      return {};
    }
  }

}
